import { validateStringEnum } from "../../../packages/validator/validator.js";

const cloudEntryTypes = ["file", "directory"] as const;

export type CloudEntryType = (typeof cloudEntryTypes)[number];

export const validateCloudEntryType = validateStringEnum(cloudEntryTypes);
